// extracted by mini-css-extract-plugin
module.exports = {"glenImage":"SignIn_glenImage__3nG8x","formSignIn":"SignIn_formSignIn__1GbF8","headerText":"SignIn_headerText__UNeA3"};